export class AddOrganizationReqVM {
    organizationID: number;
    organizationName: string;
    databaseName:string;
    address1: string;
    address2: string;
    cityID: number;
    stateID: number;
    countryID: number;
    zipCode: string;
    phoneNumber: string;
    email: string;
    password: string;
    isActive: boolean;
    createdBy: number;
    createdOn: Date;
    organizationType: number
    modifiedBy: number;
    modifiedOn: Date;
}
